namespace GeniuzPOS.AdvPromo {
    export interface Adv05HdPrintData extends Serenity.ListRequest {
        PmId?: string;
        Header?: Adv05HdRow;
        Details?: Adv05ItemDetailRow[];
        ExDetails?: Adv05ItemExDtRow[];
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
